import {CannedMessagesListProps} from './types'
import CannedMessagesListView from './CannedMessagesListView'
import React from 'react'
import {useCannedMessages} from 'hooks/cannedmessages/useSupportedLanguages'

const CannedMessagesList = (props: CannedMessagesListProps): React.ReactElement => {
    const {
        cannedMessages, cannedMessagesLanguages,
    } = useCannedMessages({organization: false})
    return (
        <CannedMessagesListView {...props} cannedMessages={cannedMessages} supportedCannedMessagesLanguages={cannedMessagesLanguages} />
    )
}

export default CannedMessagesList
